// External
import { createStore, applyMiddleware, compose } from 'redux'
import {routerMiddleware} from 'react-router-redux'
import thunk from 'redux-thunk'
import createHistory from 'history/createBrowserHistory'
import Immutable from 'immutable';
// Internal
import rootReducer from './rootReducer'
import {loadReduxLocalStorageState, saveReduxStateToLocalStorage} from './reduxLocalStorage';

import {environment, apiUrl} from '/app/src/ENV'

const history = createHistory()
/* Create enhanced history object for router */
// ==============   =STORE=================
let persistedState = loadReduxLocalStorageState();
persistedState = persistedState? persistedState: Immutable.Map();
//persistedState = Immutable.Map();
//let initialState = Immutable.fromJS({
//    'system': {
//        'api': 'https://api.jibber.social'
//    }}).merge(persistedState)
let initialState = persistedState.setIn(['system', 'api'], apiUrl)

const enhancers = []
const middleware = [
  thunk,
  routerMiddleware(history)
]


if (environment !== 'production') {
  const devToolsExtension = window.devToolsExtension
  if (typeof devToolsExtension === 'function') {
    enhancers.push(devToolsExtension())
  }
}
const composedEnhancers = compose(
  applyMiddleware(...middleware),
  ...enhancers
)
const store = createStore(
  rootReducer,
  initialState,
  composedEnhancers
)

// ==============HISTORY ================

store.subscribe(() => {
    const propsToDiscard = [
        'system',
        //'routing',
        //'user',
        'conversation',
        'customer',
        'employee',
    ];
    saveReduxStateToLocalStorage(store.getState(), propsToDiscard);
    //TODO investigate if we remove local storage once we get the props. It might leak if we
    // logout or reset without remove it.
})

export {store, history}



// WEBPACK FOOTER //
// src/store/store.js